import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'issuedno', 'uraian', 'itemno','itemname','idStore', 'nmcategory', 'headcategory', 'requestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'createby','issueGrpkey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/inventoryout${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post('/inventoryout', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/inventoryout/${obj.invIssueKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    removeReserved(obj) {
        // console.log('obj',obj)
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/inventoryout/removeReserved/${obj.invIssueKey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },
    detail(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventoryout/detail/${obj.invIssueKey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    print(obj={}){
        return new Promise(async (resolve, reject) => {
            try {
                if(obj.invIssueKey){
                    const url = `/inventoryout/print?key=${obj.invIssueKey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }
                
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    printjv(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.invIssueKey) {
                    const url = `/inventoryout/printjv?key=${obj.invIssueKey}`;
                    const { data } = await axios.get(url);
                    const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                    resolve(link);
                }

            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },    
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'issuedno', 'uraian', 'idStore', 'itemno', 'itemname','nmcategory', 'headcategory', 'requestno', 'tgl1', 'tgl2', 'DimCol', 'DimColInfo', 'DimVal', 'createby','issueGrpkey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/inventoryout/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'inventory_issued_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    issuegroup() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventoryout/issuedgroup`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    store() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventory/store`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    storeunit(unitid) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/inventory/storeunit/${unitid}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    
    posting(obj={}){
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`/inventoryout/posting/${obj.invIssueKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`/inventoryout/unposting/${obj.invIssueKey}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    
};